// extracted by mini-css-extract-plugin
var _1 = "ListItemIcons-modulechip__JTYOg";
var _2 = "ListItemIcons-moduleicons__sq9tl";
export { _1 as "chip", _2 as "icons" }
